import { Stack, Tag, Text, Wrap } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { FiBookOpen } from "react-icons/fi";
import type { PortalSourcingEventDetailDto } from "../../../../autogen/bff-api";
import { SectionCard } from "./SectionCard";

export const QualificationSchemeRulesSection = ({ event }: { event: PortalSourcingEventDetailDto }) => {
  const { t } = useTranslation();
  const categories = event.qualificationSchemeCategories ?? [];
  if (!event.qualificationSchemeRules && categories.length === 0) return null;

  return (
    <SectionCard icon={FiBookOpen} title={t("Rules for admission and management")}>
      <Stack spacing="3">
        {event.qualificationSchemeRules && (
          <Text fontSize="sm" whiteSpace="pre-wrap">
            {event.qualificationSchemeRules}
          </Text>
        )}
        {categories.length > 0 && (
          <Stack spacing="1">
            <Text fontSize="sm" fontWeight="semibold">
              {t("Categories")}
            </Text>
            <Wrap spacing="1">
              {categories.map((category) => (
                <Tag key={category} size="sm" variant="subtle">
                  {category}
                </Tag>
              ))}
            </Wrap>
          </Stack>
        )}
      </Stack>
    </SectionCard>
  );
};
